<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->    
    <v-container fluid v-if="mode=='main'">
        <v-card class="green lighten-5 pa-1">
            <Title title="苗の管理" />
            <v-container fluid style="margin-top:-20px">
                <v-row>
                    <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6" style="padding-bottom:0px">
                        <v-container fluid style="padding:0px">
                            <v-row>
                                <v-col style="padding-bottom:0px">
                                    <v-card class="pa-1">
                                        <Title title="苗の一覧" dense color="cyan">
                                            <v-spacer />
                                            <v-menu offset-y>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                        dark
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        icon>
                                                        <v-icon>mdi-menu</v-icon>
                                                    </v-btn>
                                                </template>
                                                <v-list dense>
                                                    <v-list-item
                                                        :disabled="!(selectedSeedlings.length > 0)"
                                                        @click="clearSeedlingSelection">
                                                        <v-list-item-icon><v-icon>mdi-selection-ellipse</v-icon></v-list-item-icon>
                                                        <v-list-item-title>選択解除</v-list-item-title>
                                                    </v-list-item>
                                                    <v-list-item
                                                        @click="onClickViewConditionSetting">
                                                        <v-list-item-icon><v-icon>mdi-magnify</v-icon></v-list-item-icon>
                                                        <v-list-item-title>表示条件変更</v-list-item-title>
                                                        </v-list-item>
                                                    <v-list-item
                                                        :disabled="!(shareMode == shareModeTypes.myWork)"
                                                        @click="onClickSeedlingAdd">
                                                        <v-list-item-icon><v-icon>mdi-sprout</v-icon></v-list-item-icon>
                                                        <v-list-item-title>苗追加</v-list-item-title>
                                                    </v-list-item>
                                                </v-list>
                                            </v-menu>
                                        </Title>
                                        <v-card class="ma-1 pa-1" tile outlined>
                                            <!-- <v-btn-toggle
                                                v-model="setting.seedlingList.selectMode"
                                                dense
                                                group
                                                mandatory
                                                color="primary">
                                                <v-btn :value=1 depressed x-small icon><v-icon>mdi-check</v-icon></v-btn>                                                
                                                <v-btn :value=2 depressed x-small icon><v-icon>mdi-check-all</v-icon></v-btn>                                                
                                            </v-btn-toggle> -->
                                            <v-chip class="primary" small label @click="onClickSelectionModeSeedling">
                                                <span v-if="setting.seedlingList.selectMode == 1">単行選択</span>
                                                <span v-if="setting.seedlingList.selectMode == 2">複数行選択</span>
                                            </v-chip>
                                            <v-simple-table fixed-header dense height="300"> <!-- :height="seedlingListHeight()"> -->
                                                <thead>
                                                    <tr>
                                                        <th></th>
                                                        <th style="text-align:center">名前</th>
                                                        <th style="text-align:center">品種</th>
                                                        <th style="text-align:center">状態</th>
                                                        <th style="text-align:center">場所</th>
                                                        <th style="text-align:center">育苗<br/>開始日</th>
                                                        <th style="text-align:center">栽植<br/>開始日</th>
                                                        <th style="text-align:center">観察数</th>
                                                        <th style="text-align:center">収穫数</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <template v-for="seedling in seedlings" >
                                                        <v-scroll-x-transition :key="seedling.body.seedlingID">
                                                            <tr v-if="viewMode == 0 || seedling.body.parentSeedling.seedlingID == '' || seedling.isUnknownParent == true || (seedling.isUnknownParent == false && seedling.parent.isExpand)"
                                                                v-bind:class="seedlingRowStyle(seedling)" 
                                                                @click="onSelectedSeedling(seedling)">
                                                                <td>
                                                                    <span v-if="viewMode == 0 || seedling.body.childNum == 0"/>
                                                                    <span v-else>
                                                                        <v-btn x-small icon @click.stop="seedling.isExpand = !seedling.isExpand">
                                                                            <v-icon v-if="seedling.isExpand">mdi-chevron-down</v-icon>
                                                                            <v-icon v-else>mdi-chevron-up</v-icon>
                                                                        </v-btn>
                                                                    </span>
                                                                </td>
                                                                <td v-if="viewMode == 1 && seedling.body.generationNo > 1 && seedling.isUnknownParent == false">
                                                                    <span style="font-size:xx-small" v-for="n in seedling.body.generationNo - 1" :key="n"> > </span>{{seedling.body.name}}
                                                                </td>
                                                                <td v-else-if="viewMode == 1 && seedling.body.generationNo > 1 && seedling.isUnknownParent == true">
                                                                    <!-- <span style="font-size:xx-small" v-for="n in seedling.body.generationNo - 1" :key="n"> ? </span>{{seedling.body.name}} -->
                                                                    ？{{seedling.body.name}}
                                                                </td>
                                                                <td v-else>{{seedling.body.name}}</td>
                                                                <td>{{variety(seedling.body.variety.cropID, seedling.body.variety.varietyID).name}}</td>
                                                                <td v-bind:class="seedlingRowStateStyle(seedling)" style="text-align:center">{{seedlingState(seedling.body.state).text}}</td>
                                                                <td>{{place(seedling.body.currentPlace).name}}</td>
                                                                <td style="text-align:center">{{seedling.body.results.seedling.startDate}}</td>
                                                                <td style="text-align:center">{{seedling.body.results.planting.startDate}}</td>
                                                                <td style="text-align:center">{{seedling.body.results.observatedNum}}</td>
                                                                <td style="text-align:center">{{seedling.body.results.harvestedNum}}</td>
                                                            </tr>
                                                        </v-scroll-x-transition>
                                                    </template>
                                                </tbody>
                                            </v-simple-table>
                                            <!-- <v-simple-table v-else fixed-header height="300">
                                                <tbody>
                                                    <template v-for="seedling in seedlings" >
                                                        <v-expand-transition :key="seedling.body.seedlingID">
                                                            <tr v-if="viewMode == 0 || seedling.body.parentSeedling.seedlingID == '' || seedling.isUnknownParent == true || (seedling.isUnknownParent == false && seedling.parent.isExpand)"
                                                                v-bind:class="seedlingRowStyle(seedling)" 
                                                                @click="onSelectedSeedling(seedling)">
                                                                <td>
                                                                    <v-card :class="'mt-2 mb-2 mr-2 ml-'+(seedling.body.generationNo > 1 ? 3+seedling.body.generationNo-1 : 2)">
                                                                        <v-card-text style="font-size:x-small" class="pa-1">
                                                                            <table>
                                                                                <tr>
                                                                                    <td rowspan="3">
                                                                                        <span v-if="viewMode == 0 || seedling.body.childNum == 0"/>
                                                                                        <span v-else>
                                                                                            <v-btn x-small icon @click.stop="seedling.isExpand = !seedling.isExpand">
                                                                                                <v-icon v-if="seedling.isExpand">mdi-chevron-down</v-icon>
                                                                                                <v-icon v-else>mdi-chevron-up</v-icon>
                                                                                            </v-btn>
                                                                                        </span>
                                                                                    </td>
                                                                                    <td style="width:100%; font-weight:bold">
                                                                                        <template v-if="viewMode == 1 && seedling.body.generationNo > 1 && seedling.isUnknownParent == false">
                                                                                            <span style="font-size:xx-small" v-for="n in seedling.body.generationNo - 1" :key="n"> > </span>{{seedling.body.name}}
                                                                                        </template>
                                                                                        <template v-else-if="viewMode == 1 && seedling.body.generationNo > 1 && seedling.isUnknownParent == true">
                                                                                            ？{{seedling.body.name}}
                                                                                        </template>
                                                                                        <template v-else>
                                                                                            {{seedling.body.name}}
                                                                                        </template>
                                                                                    </td>
                                                                                    <td v-bind:class="seedlingRowStateStyle(seedling)" style="text-align:center" rowspan="3">{{seedlingState(seedling.body.state).text}}</td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td>
                                                                                        {{variety(seedling.body.variety.cropID, seedling.body.variety.varietyID).name}}
                                                                                    </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td>
                                                                                        {{place(seedling.body.currentPlace).name}}
                                                                                    </td>
                                                                                </tr>
                                                                            </table>
                                                                        </v-card-text>
                                                                    </v-card>
                                                                </td>
                                                            </tr>
                                                        </v-expand-transition>
                                                    </template>
                                                </tbody>
                                            </v-simple-table> -->
                                        </v-card>
                                        <v-card class="ma-1" outlined tile>
                                            <div class="ma-2">
                                                <v-btn color="primary" class="ma-1" @click="onClickGenerationDiagramView" :disabled="!(seedlingButtonState('history'))">
                                                    <v-icon>mdi-file-tree-outline</v-icon>
                                                    苗履歴
                                                </v-btn>
                                                <v-btn class="ma-1" @click="onClickSeedlingCollect" color="primary" :disabled="!(seedlingButtonState('collect'))" key="a">
                                                    <v-icon>mdi-arrow-decision</v-icon>
                                                    採苗
                                                </v-btn>
                                                <v-btn class="ma-1" @click="onClickSeedlingObservate" color="primary" :disabled="!(seedlingButtonState('observate'))" key="b">
                                                    <v-icon>mdi-eye-circle-outline</v-icon>
                                                    観察
                                                </v-btn>
                                                <v-btn class="ma-1" @click="onClickSeedlingHarvest" color="primary" :disabled="!(seedlingButtonState('harvest'))" key="c">
                                                    <v-icon>mdi-fruit-cherries</v-icon>
                                                    収穫
                                                </v-btn>
                                                <v-btn class="ma-1" @click="onClickSeedlingStartPlanting" color="primary" :disabled="!(seedlingButtonState('planting'))" key="d">
                                                    <v-icon>mdi-arrow-collapse-down</v-icon>
                                                    定植
                                                </v-btn>
                                                <v-btn class="ma-1" @click="onClickSeedlingMove" color="primary" :disabled="!(seedlingButtonState('move'))" key="e">
                                                    <v-icon>mdi-ray-start-arrow</v-icon>
                                                    移動
                                                </v-btn>
                                                <v-btn class="ma-1" @click="onClickSeedlingDiscard" color="warning" :disabled="!(seedlingButtonState('discard'))" key="f">
                                                    <v-icon>mdi-delete</v-icon>
                                                    廃棄
                                                </v-btn>
                                                <!-- レポート -->
                                                <template>
                                                    <v-menu offset-x close-on-content-click min-width="100" max-width="300">
                                                        <template v-slot:activator="{ on }">
                                                            <v-btn
                                                                v-on="on"
                                                                class="ma-1" 
                                                                color="primary">
                                                                <v-icon>mdi-file-document-outline</v-icon>
                                                                レポート
                                                            </v-btn>
                                                        </template>
                                                        <v-list dense>
                                                            <!-- (鹿本向け) -->
                                                            <v-list-item v-if="enableReport_1000_001" @click="onSelectedKamotoReport_001()">
                                                                <v-list-item-icon><v-icon>mdi-eye</v-icon></v-list-item-icon>
                                                                <v-list-item-content>調査日誌</v-list-item-content>
                                                            </v-list-item>
                                                        </v-list>
                                                    </v-menu>
                                                </template>
                                            </div>
                                        </v-card>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-col>
                    <v-col>
                        <v-container fluid style="padding:0px">
                            <v-row>
                                <v-col v-if="observatesForView.length > 0" cols="12" style="padding-bottom:0px">
                                    <v-card class="pa-1">
                                        <Title title="苗の観察データ" dense  color="cyan" />
                                        <v-card class="ma-1 pa-1" tile outlined>
                                            <v-simple-table dense>
                                                <thead>
                                                    <tr>
                                                        <th>苗</th>
                                                        <th>
                                                            観察日
                                                            <!-- <v-btn icon x-small @click="onClickSeedlingObservateListOrder">
                                                                <v-icon v-if="setting.seedlingObservateList.order == 1">mdi-chevron-up</v-icon>
                                                                <v-icon v-if="setting.seedlingObservateList.order == 2">mdi-chevron-down</v-icon>
                                                            </v-btn> -->
                                                        </th>
                                                        <th>観察場所</th>
                                                        <th>状態</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="observate in observatesForView" :key="observate.key" @click="onSelectedSeedlingObservate(observate)">
                                                        <td>
                                                            {{observate.name}}
                                                            <!-- <v-chip v-if="observate.name != ''" class="mt-1 mb-1" color="yellow lighten-4">{{observate.name}}</v-chip> -->
                                                        </td>
                                                        <td>{{observate.body.date}}</td>
                                                        <td>{{place(observate.body.seedlingPlace.place).name}}</td>
                                                        <td>
                                                            <div v-html="seedlingObservateDataState(observate)" />
                                                        </td>
                                                        <td>
                                                            <v-icon v-if="observate.body.images.length > 0" >mdi-camera</v-icon>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </v-simple-table>
                                        </v-card>
                                    </v-card>
                                </v-col>
                                <v-col v-if="harvestsForView.length > 0" cols="12">
                                    <v-card class="pa-1">
                                        <Title title="苗の収穫物" dense color="cyan" />
                                        <v-card class="ma-1 pa-1" tile outlined>
                                            <v-chip class="primary" small @click="onClickSelectionModeHarvest">
                                                <span v-if="setting.harvestList.selectMode == 1">単行選択</span>
                                                <span v-if="setting.harvestList.selectMode == 2">複数行選択</span>
                                            </v-chip>
                                            <v-simple-table dense>
                                                <thead>
                                                    <tr>
                                                        <th>苗</th>
                                                        <th>No.</th>
                                                        <th>収穫日</th>
                                                        <th>状態</th>
                                                        <th>場所</th>
                                                        <th>観察数</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="harvest in harvestsForView" :key="harvest.key" @click="onSelectedSeedlingHarvest(harvest)" v-bind:class="harvestRowColor(harvest)">
                                                        <td>
                                                            {{harvest.name}}
                                                            <!-- <v-chip v-if="harvest.name != ''" class="mt-1 mb-1" color="yellow lighten-4">{{harvest.name}}</v-chip> -->
                                                        </td>
                                                        <td>{{harvest.body.body.harvestNo}}</td>
                                                        <td>{{harvest.body.body.date}}</td>
                                                        <td>{{harvestState(harvest.body.body.state).text}}</td>
                                                        <td>{{place(harvest.body.body.currentPlace).name}}</td>
                                                        <td>{{harvest.body.body.results.observatedNum}}</td>
                                                    </tr>
                                                </tbody>
                                            </v-simple-table>
                                        </v-card>
                                        <v-card 
                                            v-if="shareMode == shareModeTypes.myWork"
                                            class="ma-1" 
                                            outlined 
                                            tile>
                                            <div class="ma-2" >
                                                <v-btn class="ma-1" @click="onClickHarvestObservate" color="primary" :disabled="!(harvestButtonState('observate'))">
                                                    <v-icon>mdi-eye-circle-outline</v-icon>
                                                    観察
                                                </v-btn>
                                                <!-- <v-btn class="ma-1" :disabled="!(harvestButtonState('change_state'))">
                                                    状態変更
                                                </v-btn> -->
                                                <v-btn class="ma-1" @click="onClickHarvestMove" :disabled="!(harvestButtonState('move'))" color="primary">
                                                    <v-icon>mdi-ray-start-arrow</v-icon>
                                                    移動
                                                </v-btn>
                                                <v-btn class="ma-1" @click="onClickHarvestDiscard" :disabled="!(harvestButtonState('discard'))" color="warning">
                                                    <v-icon>mdi-delete</v-icon>
                                                    廃棄
                                                </v-btn>
                                            </div>
                                        </v-card>
                                        <v-card outlined class="pa-1 ma-1">
                                            <Title title="収穫物の観察データ" dense />
                                            <v-card  class="ma-1" outlined tile>
                                                <v-simple-table dense>
                                                    <thead>
                                                        <tr>
                                                            <th>苗+収穫物No.</th>
                                                            <th>観察日</th>
                                                            <th>収穫からの経過日数</th>
                                                            <th>状態</th>
                                                            <th></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="observate in harvestObservatesForView" :key="observate.key" @click="onSelectedHarvestObservate(observate)">
                                                            <td>{{observate.name}}</td>
                                                            <td>{{observate.body.date}}</td>
                                                            <td v-if="observate.body.daysFromHarvest == 0">収穫日</td>
                                                            <td v-else-if="observate.body.daysFromHarvest == 1">収穫日翌日</td>
                                                            <td v-else>{{observate.body.daysFromHarvest}}日経過</td>
                                                            <td>
                                                                <div v-html="harvestObservateDataState(observate)" />
                                                            </td>
                                                            <td>
                                                                <v-icon v-if="observate.body.images.length > 0" >mdi-camera</v-icon>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </v-simple-table>
                                            </v-card>
                                        </v-card>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
        <Register 
            ref="register" 
            :places="places" 
            :placeGroups="placeGroups"
            :crops="crops"
            @onRegisteredNewPlace="onRegisteredNewPlace"
            @onRegisteredSeedlings="onRegisteredSeedlings"/>
        <Mover
            ref="mover"
            :places="places"
            :placeGroups="placeGroups"
            :seedlings="selectedSeedlings"
            @onRegisteredNewPlace="onRegisteredNewPlace" />
        <Collector
            ref="collector"
            @onRegisteredSeedlings="onRegisteredSeedlings" />
        <Observater 
            ref="observater"
            :readOnly="shareMode != shareModeTypes.myWork"
            @onRegisteredSeedlingObservate="onRegisteredSeedlingObservate" />
        <Harvester
            ref="harvester"
            :places="places"
            :placeGroups="placeGroups"
            @onRegisteredNewPlace="onRegisteredNewPlace"
            @onRegisteredHarvests="onRegisteredHarvests" />
        <HarvestObservater 
            ref="harvestObservater"
            :readOnly="shareMode != shareModeTypes.myWork"
            @onRegisteredHarvestObservate="onRegisteredHarvestObservate" />
        <HarvestMover
            ref="harvestMover"
            :places="places"
            :placeGroups="placeGroups"
            :harvests="selectedHarvests"
            @onRegisteredNewPlace="onRegisteredNewPlace" />
        <ViewCondition
            ref="viewCondition"
            :viewCondition="viewCondition"
            :places="places"
            :crops="crops"
            @onChangedViewCondition="refreshSeedlingList" />
        <Confirm ref="confirm" />
        <KamotoReport001 ref="kamoto_001" :seedlings="seedlings" />
    </v-container>
    <SeedlingHistoryDiagram
        v-else-if="mode=='seedling_history'"
        :targetSeedling="selectedSeedlings[0]"
        :places="places"
        @onCloseGenerationDiagram="onCloseGenerationDiagram" />
</template>

<script>
    import db from '@/firebase/firestore.js'
    import Title from '@/components/seedling/items/TitleBar'
    import TitleButton from '@/components/tools/TitleBarButton';
    import Register from '@/components/seedling/items/Register'
    import Mover from '@/components/seedling/items/Mover'
    import Collector from '@/components/seedling/items/Collector'
    import Observater from '@/components/seedling/items/Observater'
    import Harvester from '@/components/seedling/items/Harvester'
    import HarvestObservater from '@/components/seedling/items/HarvestObservater'
    import HarvestMover from '@/components/seedling/items/HarvestMover'
    import ViewCondition from '@/components/seedling/items/ViewCondition'
    import SeedlingHistoryDiagram from '@/components/seedling/items/SeedlingHistoryDiagram'
    import KamotoReport001 from '@/components/seedling/addin/KamotoReport_001'
    import Confirm from '@/components/tools/ConfirmDialog';
    export default {
        components: {
            Title,
            TitleButton,
            Register,
            Mover,
            Collector,
            Observater,
            Harvester,
            HarvestObservater,
            HarvestMover,
            ViewCondition,
            SeedlingHistoryDiagram,
            KamotoReport001,
            Confirm
        },
        computed: {
            enableReport_1000_001: function () {
                const license = this.$store.getters["loggedInUserLicense"]
                if (license == null) {
                    return false
                }
                if (license.addins.findIndex((v)=>v == "1000-001") < 0) {
                    return false
                }
                return true
            },
            shareMode: function () {
                return this.$store.getters["shareMode"]
            },
            shareModeTypes: function () {
                return this.$store.getters["shareModeTypes"]
            },
            userData: function () {
                return this.$store.getters["userData"]
            },
            seedlingRowStyle: function () {
                return function(seedling) {
                    var v = ""
                    if (seedling.isSelecting) {
                        v = "light-green lighten-4"
                    } else {
                        v = "white"
                    }      
                    // switch (seedling.body.state) {
                    //     case 1:
                    //         v += " green--text"
                    //         break;
                    //     case 2:
                    //         v += " red--text"
                    //         break;
                    //     case 99:
                    //         v += " grey--text"
                    //         break;
                    // }
                    // if (seedling.body.childNum > 0) {
                    //     // v += " font-weight-black"
                    // } else {
                    //     v += " font-weight-regular"
                    // }
                    // if (seedling.isUnknownParent) {
                    //     v += " font-italic"
                    // }
                    return v
                }
            },
            seedlingRowStateStyle: function () {
                return function(seedling) {
                    var v = ""
                    switch (seedling.body.state) {
                        case 1:
                            v += " green--text"
                            break;
                        case 2:
                            v += " red--text"
                            break;
                        case 99:
                            v += " grey--text"
                            break;
                    }
                    if (seedling.body.childNum > 0) {
                        // v += " font-weight-black"
                    } else {
                        v += " font-weight-regular"
                    }
                    if (seedling.isUnknownParent) {
                        v += " font-italic"
                    }
                    return v
                }
            },
            harvestRowColor: function () {
                const self = this
                return function(harvest) {
                    var v = ""
                    if (self.selectedHarvests.findIndex((v)=>v.body.body.seedlingID === harvest.body.body.seedlingID && v.body.body.harvestNo === harvest.body.body.harvestNo) >= 0) {
                        v = "light-green lighten-4"
                    } else {
                        v = "white"
                    }
                    switch (harvest.body.body.state) {
                        case 99:
                            v += " grey--text"
                            break;
                    }
                    return v
                }
            },
            seedlingState: function () {
                const self = this
                return function (state) {
                    const index = self.states.findIndex((v)=>v.value === state)
                    return self.states[index]
                }
            },
            harvestState: function () {
                const self = this
                return function (state) {
                    const index = self.harvestStates.findIndex((v)=>v.value === state)
                    return self.harvestStates[index]
                }
            },
            place: function () {
                const self = this
                return function (place) {
                    const index = self.places.findIndex((v)=>v.placeID === place)
                    return self.places[index]
                }
            },
            crop: function () {
                const self = this
                return function  (cropID) {
                    const cropIndex = self.crops.findIndex((v)=>v.body.cropID === cropID)
                    return self.crops[cropIndex].body
                }
            },
            variety: function () {
                const self = this
                return function  (cropID, varietyID) {
                    const cropIndex = self.crops.findIndex((v)=>v.body.cropID === cropID)                    
                    const varietyIndex = self.crops[cropIndex].varieties.findIndex((v)=>v.varietyID === varietyID)
                    return self.crops[cropIndex].varieties[varietyIndex]
                }
            },
            // 観察データリスト(一覧表示用)
            // observates: [] {
            //     key: キー,
            //     name: 苗の名前(苗毎の先頭行のみ),
            //     seedling: 苗,
            //     body: 観察データ
            // }
            observatesForView: function () {
                var list = []
                var key = 1
                for (var i=0; i<this.selectedSeedlings.length; i++) {
                    const observates = this.selectedSeedlings[i].observates
                    if (observates != null) {
                        for (var j=0; j<observates.length; j++){
                            var name = ""
                            if (j==0) {
                                name = this.selectedSeedlings[i].body.name
                            }
                            list.push({                                
                                key: key,
                                name: name,
                                seedling: this.selectedSeedlings[i],
                                body: observates[j]
                            })
                            key++
                        }
                    }
                }
                return list
            },
            // 収穫データリスト(一覧表示用)
            // harvests: [] {
            //     key: キー,
            //     name: 苗の名前(苗毎の先頭行のみ),
            //     seedling: 苗,
            //     body: 収穫データ
            // }
            harvestsForView: function () {
                var list = []
                var key = 1
                for (var i=0; i<this.selectedSeedlings.length; i++) {
                    const harvests = this.selectedSeedlings[i].harvests
                    if (harvests != null) {
                        for (var j=0; j<harvests.length; j++){
                            var name = ""
                            if (j==0) {
                                name = this.selectedSeedlings[i].body.name
                            }
                            list.push({
                                key: key,
                                name: name,
                                seedling: this.selectedSeedlings[i],
                                body: harvests[j]
                            })
                            key++
                        }
                    }
                }
                return list
            },
            // 収穫物の観察データリスト(一覧表示用)
            // harvests: [] {
            //     key: キー,
            //     name: 苗の名前+収穫No (※(苗毎の先頭行のみ)),
            //     seedling: 苗,
            //     body: 観察データ
            // }
            harvestObservatesForView: function () {
                var list = []
                var key = 1
                for (var i=0; i<this.selectedHarvests.length; i++) {
                    const observates = this.selectedHarvests[i].body.observates
                    if (observates != null) {
                        for (var j=0; j<observates.length; j++){
                            var name = ""
                            if (j==0) {
                                name = this.selectedHarvests[i].seedling.body.name + "-" + this.selectedHarvests[i].body.body.harvestNo
                            }
                            list.push({                                
                                key: key,
                                name: name,
                                seedling: this.selectedHarvests[i].seedling,
                                body: observates[j]
                            })
                            key++
                        }
                    }
                }
                return list
            }
        },
        data: function () {
            return {
                mode: 'main',
                states: [
                    {value: 1, text:"育苗中"},
                    {value: 2, text:"栽植中"},
                    {value: 99, text:"廃棄"},
                ],
                harvestStates: [
                    {value: 10, text:"観察"},
                    {value: 20, text:"出荷"},
                    {value: 99, text:"廃棄"},
                ],
                // ======================
                // 登録されている全ての場所
                places: [],
                // ======================
                // 登録されている全ての場所グループ
                placeGroups: [],
                // ======================
                // 条件に該当する全ての苗
                // seedlings: [{
                //     isSelecting: boolean,
                //     body: seedling   苗データ
                //     observates:[]    この苗の全観察データ(初期値はnull)
                //     harvests: [{     この苗の全収穫データ(初期値はnull)
                //         body: harvest,      // 収穫物
                //         observates: []      // 収穫物の全観察データ(初期値はnull)
                //     }]     
                // }]
                seedlings: [],
                // ======================
                // 登録されている全作物
                // crops: [{
                //     body: crop,
                //     varieties: []
                // }]
                crops: [],
                // ======================
                // 選択されている全ての苗
                selectedSeedlings: [],
                // ======================
                // 選択されている全ての収穫物
                selectedHarvests: [],
                // ======================
                // 表示モード
                // 0:通常,1:親子を纏める
                viewMode: 0,
                // ====================================
                // 表示条件
                // 初期値は、showメソッドにおいて設定
                viewCondition: {
                    condition: {
                        targetDate: {
                            value: {
                                year: null,
                                month: null,
                                day: null
                            }
                        },
                        name: {enabled: false, value:null},
                        place: {enabled: false, value:null},
                        variety: {
                            enabled: false,
                            value: {
                                cropID: null,
                                varietyID: null,
                            }
                        },
                        state: {enabled: false, value:null},
                        isDiscardedNotView: false,
                        isOrderOfGeneration: false,
                    },
                    orders: [],
                },
                // ====================================
                // 動作設定
                setting: {
                    // ====================================
                    // 苗の一覧設定
                    seedlingList: {
                        selectMode: 1,  // 選択モード(1:単行, 2:複数行)
                    },
                    // ====================================
                    // 苗の観察データ一覧設定
                    seedlingObservateList: {
                        order: 1,       // 並び順(1:観察日の昇順,2:観察日の降順)
                    },
                    // ====================================
                    // 苗の収穫物一覧設定
                    harvestList: {
                        selectMode: 1,  // 選択モード(1:単行, 2:複数行)
                    },
                }
            }
        },
        mounted: async function () {

            const self = this

            const license = this.$store.getters["loggedInUserLicense"]
            
            if (license == null || license.addins.findIndex((v)=>v=="1000-000") < 0) {
                this.$refs.confirm.show({
                    title: "苗管理",
                    message: "こちらの機能は現在有効になっていません。<br/>OKを押すと、ホーム画面に戻ります。",
                    width: 500,
                    buttonYes: "OK",
                    buttonNo: "",
                    listenerYes: function () {
                        self.$store.commit("requestBackToHome", true)
                        return true
                    },
                })

                return
            }

            const userUID = this.$store.getters["userUID"]

            this.mode = 'main'
            this.places = []
            this.placeGroups = []
            this.seedlings = []
            this.crops = []

            this.$store.commit("processing", {start:true, message:"処理中です"})

            try {
                // // 観察項目のデータが無ければ、システムのテンプレートをコピー
                // await db.collection("users").doc(userUID).collection("managements").doc("observate").collection("observate_items").get().then(function(snapShot){
                //     if (snapShot.size == 0) {
                //         db.collection("system").doc("template").collection("observate_items").get().then(function(snapShot){
                //             snapShot.forEach(function(doc){
                //                 const item = doc.data()
                //                 db.collection("users").doc(userUID).collection("managements").doc("observate").collection("observate_items").doc(""+item.id).set(item).then(function(){
                //                     console.log("observate item copied", item)
                //                 })
                //             })
                //         })
                //     }
                // })

                // 登録済みの全場所グループ取得
                await db.collection("users").doc(userUID).collection("managements").doc("place_group").collection("groups").get().then(function(snapShot){
                    snapShot.forEach(function(doc){
                        self.placeGroups.push(doc.data())
                    })
                })

                // 登録済みの全場所取得
                await db.collection("users").doc(userUID).collection("places").get().then(function(snapShot){
                    snapShot.forEach(function(doc){
                        self.places.push(doc.data())
                    })
                })

                // 登録済みの全作物取得
                await db.collection("users").doc(userUID).collection("crops").get().then(function(snapShot){                
                    snapShot.forEach(function(doc){
                        const crop = {
                            body: doc.data(),
                            varieties: []
                        }
                        self.crops.push(crop)
                        db.collection("users").doc(userUID).collection("crops").doc(""+crop.body.cropID).collection("varieties").get().then(function(snapShot){
                            snapShot.forEach(function(doc){
                                crop.varieties.push(doc.data())
                            })
                        })
                    })
                })

                // 登録済みの表示条件
                if (this.shareMode == this.shareModeTypes.myWork) {
                    await db.collection("users").doc(userUID).collection("managements").doc("seedling").collection("view_condition").doc("condition").get().then(function(doc){
                        const condition = doc.data()
                        if (condition != null) {
                            console.log("view condition registered", condition)
                            self.viewCondition = condition
                            self.refreshSeedlingList(self.viewCondition)
                        } else {
                            const currentDate = new Date()
                            self.viewCondition.condition.targetDate.value.year = currentDate.getFullYear() * 1
                            self.viewCondition.condition.targetDate.enabled = true
                            self.viewCondition.condition.isDiscardedNotView = true
                            self.viewCondition.condition.isOrderOfGeneration = true
                            console.log("view condition not regist", self.viewCondition)

                            // 表示条件設定画面表示
                            self.onClickViewConditionSetting()
                        }
                    })
                } else {
                    this.onClickViewConditionSetting()
                }

                self.$store.commit("processing", {start:false})

            } catch (error) {
                console.log(error)
                self.$store.commit("processing", {start:false})
            }
        },
        methods: {
            /**
             * 鹿本向け調査日誌ボタン押下時
             */
            onSelectedKamotoReport_001: function () {
                
                this.$refs.kamoto_001.show(this.setObservateListTo, this.place, this.crop, this.variety)

            },
            seedlingListHeight: function () {
                if (this.seedlings.length >= 23) {
                    return 600
                }
                return null
            },
            onCloseGenerationDiagram: function () {
                this.mode = 'main'
            },
            // =============================================
            // 苗データ選択時(行選択時)
            onSelectedSeedling: function (seedling) {
                console.log(seedling)
                switch (this.setting.seedlingList.selectMode) {
                    case 1:
                        if (seedling.isSelecting) {
                            seedling.isSelecting = false
                            this.selectedSeedlings.splice(0, 1)
                        } else {
                            if (this.selectedSeedlings.length > 0) {
                                this.selectedSeedlings[0].isSelecting = false
                                this.selectedSeedlings.splice(0, 1)
                            }
                            this.selectedSeedlings.push(seedling)
                            seedling.isSelecting = true
                        }
                        break;
                    case 2:
                        const index = this.selectedSeedlings.findIndex((v)=>v.body.seedlingID === seedling.body.seedlingID)
                        if (seedling.isSelecting) {
                            this.selectedSeedlings.splice(index, 1)                    
                        } else {
                            this.selectedSeedlings.push(seedling)
                        }
                        seedling.isSelecting = !seedling.isSelecting                        
                        break;
                }
                if (seedling.observates == null) {
                    this.setObservateListTo(seedling)
                }
                
                if (seedling.harvests == null) {
                    this.setHarvestListTo(seedling)
                }
            },
            // =============================================
            // 苗の観察データ選択時(行選択時)
            onSelectedSeedlingObservate: function (observate) {
                this.$refs.observater.show(observate.seedling.body, observate.seedling.observates, observate.body)
            },
            // =============================================
            // 苗の収穫物選択時(行選択時)
            onSelectedSeedlingHarvest: function (harvest) {
                switch (this.setting.harvestList.selectMode) {
                    case 1:
                        if (this.selectedHarvests.length == 1) {
                            this.selectedHarvests.splice(0, 1)
                        }
                        this.selectedHarvests.push(harvest)
                        break;
                    case 2:
                        const index = this.selectedHarvests.findIndex(
                            (v)=>v.body.body.seedlingID === harvest.body.body.seedlingID && v.body.body.harvestNo === harvest.body.body.harvestNo
                        )
                        if (index < 0) {
                            this.selectedHarvests.push(harvest)
                        } else {
                            this.selectedHarvests.splice(index, 1)
                        }
                        break;
                }
                if (harvest.body.observates == null) {
                    this.setHarvestObservateListTo(harvest.body)
                }                    

                // const index = this.selectedHarvests.findIndex(
                //     (v)=>v.body.body.seedlingID === harvest.body.body.seedlingID && v.body.body.harvestNo === harvest.body.body.harvestNo
                // )
                // if (index < 0) {
                //     this.selectedHarvests.push(harvest)
                //     if (harvest.body.observates == null) {
                //         this.setHarvestObservateListTo(harvest.body)
                //     }                    
                // } else {
                //     this.selectedHarvests.splice(index, 1)
                // }
            },
            // =============================================
            // 苗の収穫物の観察データ選択時(行選択時)
            onSelectedHarvestObservate: function (observate) {
                this.$refs.harvestObservater.show(
                    this.selectedHarvests[0].seedling.body, 
                    this.selectedHarvests[0].body.body,
                    observate.body
                )
            },
            // =============================================
            // 苗一覧の選択モード押下時
            onClickSelectionModeSeedling: function () {
                switch (this.setting.seedlingList.selectMode) {
                    case 1:
                        this.setting.seedlingList.selectMode = 2
                        break
                    case 2:
                        this.setting.seedlingList.selectMode = 1
                        break
                }
                this.clearSeedlingSelection()
            },
            // =============================================
            // 収穫物一覧の選択モード押下時
            onClickSelectionModeHarvest: function () {
                switch (this.setting.harvestList.selectMode) {
                    case 1:
                        this.setting.harvestList.selectMode = 2
                        break
                    case 2:
                        this.setting.harvestList.selectMode = 1
                        break
                }
            },
            // =============================================
            // 表示設定ボタン押下時
            onClickViewConditionSetting: function () {
                this.$refs.viewCondition.show()
            },
            // =============================================
            // 苗の追加ボタン押下時
            onClickSeedlingAdd: function () {
                this.$refs.register.show()
            },
            // =============================================
            // 苗履歴ボタン押下時
            onClickGenerationDiagramView: function () {
                this.mode = 'seedling_history'
            },
            // =============================================
            // 苗の定植ボタン押下時
            onClickSeedlingStartPlanting: function () {
                // 定植モードで、移動画面を表示
                this.$refs.mover.show(1)
            },
            // =============================================
            // 苗の観察ボタン押下時
            onClickSeedlingObservate: function () {
                this.$refs.observater.show(this.selectedSeedlings[0].body, this.selectedSeedlings[0].observates)
            },
            // =============================================
            // 苗の収穫ボタン押下時
            onClickSeedlingHarvest: function () {
                this.$refs.harvester.show(this.selectedSeedlings[0].body)
            },
            // =============================================
            // 苗の移動ボタン押下時
            onClickSeedlingMove: function () {
                // 移動モードで、移動画面を表示
                this.$refs.mover.show(2)
            },
            // =============================================
            // 苗の採苗ボタン押下時
            onClickSeedlingCollect: function () {
                this.$refs.collector.show(this.selectedSeedlings[0].body)
            },
            // =============================================
            // 苗の廃棄ボタン押下時
            onClickSeedlingDiscard: function () {
                // 廃棄モードで、移動画面を表示
                this.$refs.mover.show(99, this.discardedSeedlings)
                // const self = this
                // this.$refs.confirm.show({
                //     title: "苗",
                //     message: "選択されている苗を全て廃棄しますか？",
                //     buttonYes: "廃棄する",
                //     buttonNo: "いいえ",
                //     width: 400,
                //     listenerYes: function () {
                //         self.discardSeedlings()
                //         return true
                //     },
                // })
            },
            // =============================================
            // 収穫物の観察ボタン押下時
            onClickHarvestObservate: function () {
                console.log("onClickHarvestObservate")
                this.$refs.harvestObservater.show(
                    this.selectedHarvests[0].seedling.body, 
                    this.selectedHarvests[0].body.body
                )
            },
            // =============================================
            // 収穫物の移動ボタン押下時
            onClickHarvestMove: function () {
                this.$refs.harvestMover.show(2)
            },
            // =============================================
            // 収穫物の廃棄ボタン押下時
            onClickHarvestDiscard: function () {
                this.$refs.harvestMover.show(99)
            },
            // =============================================
            // 新しい場所が登録された時
            onRegisteredNewPlace: function (place) {
                this.places.push(place)
            },
            // =============================================
            // 新しい苗が登録された時
            onRegisteredSeedlings: function (seedlings) {
                const self = this
                seedlings.forEach(function(seedling, index) {
                    self.seedlings.push({
                        isSelecting: false,
                        body: seedling,
                        observates: null,
                        harvests: null,
                        isUnknownParent: false,
                        parent: null,
                        isExpand: false
                    })
                    if (index == seedlings.length - 1 && self.viewCondition.condition.isOrderOfGeneration) {
                        self.summaryToParent()
                    }
                })
            },
            // =============================================
            // 新しい収穫データが登録された時
            onRegisteredHarvests: function (harvests) {
                const self = this
                harvests.forEach(function(harvest){
                    self.selectedSeedlings[0].harvests.push({
                        body: harvest,
                        observates: null
                    })
                })
            },
            // =============================================
            // 苗の新しい観察データが登録された時
            // params: {
            //     seedling: 苗,
            //     observate: 登録された観察データ
            // }
            onRegisteredSeedlingObservate: function (params) {
                this.selectedSeedlings[0].observates.push(params.observate)
                this.sortSeedlingObservateList(this.selectedSeedlings[0].observates)
            },
            // =============================================
            // 収穫物の新しい観察データが登録された時
            // params: {
            //     seedling: 苗,
            //     harvest: 収穫データ,
            //     observate: 登録された観察データ
            // }
            onRegisteredHarvestObservate: function (params) {
                this.selectedHarvests[0].body.observates.push(params.observate)
            },
            // =============================================
            // 苗の観察データの状態を返す
            // observate: {
            //     key: キー,
            //     name: 苗の名前(苗毎の先頭行のみ),
            //     seedling: 苗,
            //     body: 収穫データ
            // }
            seedlingObservateDataState: function (observate) {
                if (observate.body.values.findIndex((v)=>v.value == null) >= 0) {
                    return "<span class='warning--text'>未観察項目有り</span>"
                }
                return ""
            },
            // =============================================
            // 収穫物の観察データの状態を返す
            // observate: {
            //     key: キー,
            //     name: 苗の名前+収穫No (※(苗毎の先頭行のみ)),
            //     seedling: 苗,
            //     body: 観察データ
            // }
            harvestObservateDataState: function (observate) {
                if (observate.body.values.findIndex((v)=>v.value == null) >= 0) {
                    return "<span class='warning--text'>未観察項目有り</span>"
                }
                return ""
            },
            // =============================================
            // 指定された苗に、その苗で登録されている全観察データをセット
            setObservateListTo: function (seedling, completed) {
                const self = this
                const userUID = this.$store.getters["userUID"]
                seedling.observates = []
                db.collection("users").doc(userUID).collection("seedlings").doc(seedling.body.seedlingID).collection("observates").get().then(function(snapShot){
                    if (snapShot.size == 0 && completed != null) {
                        completed()
                    } else {
                        snapShot.forEach(function(doc){
                            seedling.observates.push(doc.data())
                            if (seedling.observates.length == snapShot.size) {
                                self.sortSeedlingObservateList(seedling.observates, false)
                                if (completed != null) {
                                    completed()
                                }
                            }
                        })
                    }
                })
            },
            // =============================================
            // 指定された苗に、その苗で登録されている全収穫データをセット
            setHarvestListTo: function (seedling) {
                const self = this
                const userUID = this.$store.getters["userUID"]
                seedling.harvests = []
                db.collection("users").doc(userUID).collection("seedlings").doc(seedling.body.seedlingID).collection("harvests").get().then(function(snapShot){
                    snapShot.forEach(function(doc){
                        seedling.harvests.push(
                            {
                                body: doc.data(),
                                observates: null
                            })
                    })
                })
            },
            // =============================================
            // 指定された収穫物に、その収穫物で登録されている全観察データをセット
            setHarvestObservateListTo: function (harvest) {
                const self = this
                const userUID = this.$store.getters["userUID"]
                harvest.observates = []
                db.collection("users").doc(userUID)
                .collection("seedlings").doc(harvest.body.seedlingID)
                .collection("harvests").doc(""+harvest.body.harvestNo)
                .collection("observates").get().then(function(snapShot){
                    snapShot.forEach(function(doc){
                        harvest.observates.push(doc.data())
                    })
                })
            },
            // =============================================
            // 指定された観察データの配列を並び替える
            sortSeedlingObservateList: function (observates) {
                var isAsc = true
                switch (this.setting.seedlingObservateList.order) {
                    case 1: isAsc = true; break;
                    case 2: isAsc = false; break;
                }
                observates.sort(function(a, b){
                    var v = 1
                    if (!isAsc) {
                        v=-1
                    }
                    if (a.date > b.date) {
                        return 1 * v
                    }
                    if (a.date < b.date) {
                        return -1 * v
                    }
                    return 0
                })
            },
            // =============================================
            // 選択されている苗の廃棄処理終了後
            discardedSeedlings: function () {
                console.log("discardedSeedlings")
                const self = this
                if (this.viewCondition.condition.isDiscardedNotView) {
                    const newList = []
                    self.selectedSeedlings.forEach(function(seedling, index){
                        var targetIndex = self.seedlings.findIndex((v)=>v.body.seedlingID == seedling.body.seedlingID)
                        self.seedlings.splice(targetIndex, 1)
                        if (index == self.selectedSeedlings.length - 1) {
                            self.clearSeedlingSelection()
                            if (self.viewCondition.condition.isOrderOfGeneration) {
                                self.summaryToParent()
                            }
                        }
                    })
                }
            },
            // // =============================================
            // // 選択されている収穫物の廃棄処理
            // discardHarvests: function () {
            //     const self = this
            //     const userUID = this.$store.getters["userUID"]
                
            //     var batch = db.batch()

            //     for (var i=0; i<this.selectedHarvests.length; i++) {                    
            //         var seedling = this.selectedHarvests[i].seedling.body
            //         var harvest = this.selectedHarvests[i].body.body
            //         harvest.state = 99
            //         batch.update(
            //             db.collection("users").doc(userUID).collection("seedlings").doc(seedling.seedlingID).collection("harvests").doc(""+harvest.harvestNo), 
            //             {
            //                 "state": 99,
            //                 "updater": {
            //                     userUID: userUID,
            //                     dateTime: this.df_currentDateTime()
            //                 }
            //             }
            //         )
            //     }

            //     batch.commit().then(function(){
            //         self.$store.commit("notification", {message:"収穫物を廃棄しました。"})
            //     }).catch (function (error) {
            //         console.log(error)
            //         self.$store.commit("notification", {message:"収穫物の廃棄に失敗しました。", isError:true})
            //     })
            // },
            // =============================================
            // 苗の選択全解除
            clearSeedlingSelection: function () {
                this.selectedSeedlings = []
                this.seedlings.forEach(function(seedling){
                    seedling.isSelecting = false
                })
            },
            // =============================================
            // 苗の一覧表示更新
            // viewCondition: {
            //     condition: {
            //         targetDate: {
            //             value: {
            //                 year: null,
            //                 month: null,
            //                 day: null
            //             }
            //         },
            //         name: {enabled: false, value:null},
            //         place: {enabled: false, value:null},
            //         variety: {
            //             enabled: false,
            //             value: {
            //                 cropID: null,
            //                 varietyID: null,
            //             }
            //         },
            //         state: {enabled: false, value:null},
            //         isDiscardedNotView: true
            //         isOrderOfGeneration: false,
            //     },                    
            //     orders [],
            // },
            refreshSeedlingList: function (viewCondition) {
                console.log("refreshSeedlingList", viewCondition)

                const self = this
                const userUID = this.$store.getters["userUID"]

                // 表示条件を保存(グループメンバー参照時は行わない)
                if (this.shareMode == this.shareModeTypes.myWork) {
                    db.collection("users").doc(userUID).collection("managements").doc("seedling").collection("view_condition").doc("condition").set(viewCondition).then(function(){
                        console.log("view condition regist success")
                    }).catch(function(error){
                        console.log("view condition regist failed", error)
                    })
                }

                // 日付範囲を作成して検索
                var dateRangeFrom = ""
                var dateRangeTo = ""
                if (viewCondition.condition.targetDate.value.month == null) {
                    console.log("condition-1")
                    dateRangeFrom = viewCondition.condition.targetDate.value.year + "-01-01"
                    dateRangeTo = viewCondition.condition.targetDate.value.year + "-12-31"
                } else if (viewCondition.condition.targetDate.value.day == null) {
                    console.log("condition-2")
                    dateRangeFrom = 
                        viewCondition.condition.targetDate.value.year + "-" 
                        + ("0"+viewCondition.condition.targetDate.value.month).slice(-2) + "-"
                        + "01"
                    dateRangeTo = 
                        viewCondition.condition.targetDate.value.year + "-" 
                        + ("0"+viewCondition.condition.targetDate.value.month).slice(-2) + "-"
                        + "31"
                } else {
                    console.log("condition-3")
                    dateRangeFrom = 
                        viewCondition.condition.targetDate.value.year + "-" 
                        + ("0"+viewCondition.condition.targetDate.value.month).slice(-2) + "-"
                        + ("0"+viewCondition.condition.targetDate.value.day).slice(-2)
                    dateRangeTo = 
                        viewCondition.condition.targetDate.value.year + "-" 
                        + ("0"+viewCondition.condition.targetDate.value.month).slice(-2) + "-"
                        + ("0"+viewCondition.condition.targetDate.value.day).slice(-2)
                }

                console.log(dateRangeFrom, dateRangeTo)

                this.seedlings = []
                this.selectedSeedlings = []

                var docSeedlings = db.collection("users").doc(userUID).collection("seedlings")
                                   .where("results.seedling.startDate", ">=", dateRangeFrom)
                                   .where("results.seedling.startDate", "<=", dateRangeTo)

                if (viewCondition.condition.isDiscardedNotView) {
                    docSeedlings = docSeedlings.where("state", "in", [1, 2])
                }

                var scannedNum = 0

                docSeedlings.get().then(function(snapShot){
                    snapShot.forEach(function(doc){                        
                        const seedling = doc.data()

                        var results = []

                        // 条件毎の結果を配列に格納する。(結果がtrueは、その条件に該当する事を表す)
                        // 名前
                        results.push(viewCondition.condition.name.enabled == false || seedling.name.indexOf(viewCondition.condition.name.value) >= 0)
                        // 場所
                        results.push(viewCondition.condition.place.enabled == false || seedling.currentPlace == viewCondition.condition.place.value)
                        // 品種
                        results.push(
                            viewCondition.condition.variety.enabled == false || 
                            (seedling.variety.cropID == viewCondition.condition.variety.value.cropID && seedling.variety.varietyID == viewCondition.condition.variety.value.varietyID))
                        // 状態
                        results.push(viewCondition.condition.state.enabled == false || seedling.state == viewCondition.condition.state.value)
                        // 廃棄
                        results.push(viewCondition.condition.isDiscardedNotView == false || seedling.state != 99)

                        if (results.findIndex((v)=>v==false) < 0) {
                            self.seedlings.push({
                                isSelecting: false,
                                body: seedling,
                                observates: null,
                                harvests: null,
                                isUnknownParent: false,
                                parent: null,
                                isExpand: false
                            })
                        }

                        scannedNum++
                        if (scannedNum == snapShot.size && viewCondition.condition.isOrderOfGeneration) {
                            self.viewMode = 1
                            self.summaryToParent()
                        } else {
                            self.viewMode = 0
                        }
                    })
                })
            },
            summaryToParent: function () {

                console.log("summaryToParent", this.seedlings, this.seedlings.length)
                const self = this

                var newList = []

                // ===========================
                // 全苗データを一旦配列にコピー
                var targetSeedlings = []

                for (var i=0; i<this.seedlings.length; i++) {
                    const seedling = this.seedlings[i]
                    targetSeedlings.push(
                        {
                            seedling: seedling,
                            isMoved: false
                        }
                    )
                }

                var childSetter = function (target) {                    
                    for (var i=0; i<targetSeedlings.length; i++) {
                        if (targetSeedlings[i].isMoved) {
                            continue
                        }
                        if (targetSeedlings[i].seedling.body.parentSeedling.seedlingID == target.seedling.body.seedlingID && targetSeedlings[i].seedling.body.generationNo == (target.seedling.body.generationNo + 1)) {
                            target.seedling.isExpand = true
                            newList.push(targetSeedlings[i].seedling)
                            targetSeedlings[i].seedling.parent = target.seedling
                            targetSeedlings[i].isMoved = true
                            if (targetSeedlings[i].seedling.body.childNum > 0) {
                                childSetter(targetSeedlings[i])
                            }
                        }
                    }
                }

                const maxGenerationNo = Math.max(...targetSeedlings.map(m => m.seedling.body.generationNo))

                for (var generationNo = 1; generationNo <= maxGenerationNo; generationNo++) {
                    for (var i=0; i<targetSeedlings.length; i++) {
                        if (targetSeedlings[i].isMoved == false && targetSeedlings[i].seedling.body.generationNo == generationNo) {
                            newList.push(targetSeedlings[i].seedling)
                            targetSeedlings[i].isMoved = true
                            if (targetSeedlings[i].seedling.body.childNum > 0) {
                                childSetter(targetSeedlings[i])
                            }
                        }
                    }
                }
                
                this.seedlings = newList

                console.log(newList)
                newList.forEach(function(item){
                    if (item.body.generationNo > 1) {
                        console.log(item.body.parentSeedling.seedlingID)
                        if (newList.findIndex((v)=>v.body.seedlingID == item.body.parentSeedling.seedlingID) < 0) {
                            item.isUnknownParent = true
                        }
                    }
                })

                return
            },
            seedlingButtonState: function (buttonName) {
                switch (buttonName) {
                    case "history":     // 履歴
                        if (this.selectedSeedlings.length == 1) {
                            return true
                        }
                        return false
                    case "collect":     // 採苗
                        if (this.shareMode != this.shareModeTypes.myWork) {
                            return false
                        }
                        if (this.selectedSeedlings.length == 1 && this.selectedSeedlings[0].body.state != 99) {
                            return true
                        }
                        return false
                    case "observate":   // 観察
                        if (this.shareMode != this.shareModeTypes.myWork) {
                            return false
                        }
                        if (this.selectedSeedlings.length == 1 && this.selectedSeedlings[0].body.state != 99) {
                            return true
                        }
                        return false
                    case "harvest":     // 収穫
                        if (this.shareMode != this.shareModeTypes.myWork) {
                            return false
                        }
                        if (this.selectedSeedlings.length != 1) {
                            return false
                        }
                        // 選択されている苗が廃棄されている時は、不可
                        if (this.selectedSeedlings[0].body.state == 99) {
                            return false
                        }
                        // 選択されている苗が栽植中であれば、可能
                        if (this.selectedSeedlings[0].body.state == 2) {
                            return true
                        }
                        return false
                    case "planting":    // 定植
                        if (this.shareMode != this.shareModeTypes.myWork) {
                            return false
                        }
                        if (this.selectedSeedlings.length < 1) {
                            return false
                        }
                        // 選択されている苗に育苗状態以外の苗が含まれている時は、不可
                        if (this.selectedSeedlings.findIndex((v)=>v.body.state != 1) >= 0) {
                            return false
                        }
                        return true
                    case "move":        // 移動
                        if (this.shareMode != this.shareModeTypes.myWork) {
                            return false
                        }
                        if (this.selectedSeedlings.length < 1) {
                            return false
                        }
                        // 選択されている苗に育苗状態以外の苗が含まれている時は、不可
                        if (this.selectedSeedlings.findIndex((v)=>v.body.state != 1) >= 0) {
                            return false
                        }
                        return true
                    case "discard":     // 廃棄
                        if (this.shareMode != this.shareModeTypes.myWork) {
                            return false
                        }
                        if (this.selectedSeedlings.length < 1) {
                            return false
                        }
                        // 選択されている苗に廃棄状態の苗が含まれている時は、不可
                        if (this.selectedSeedlings.findIndex((v)=>v.body.state == 99) >= 0) {
                            return false
                        }
                        return true
                }
            },
            harvestButtonState: function (buttonName) {
                switch (buttonName) {
                    case "observate":
                        if (this.selectedHarvests.length != 1) {
                            return false
                        }
                        if (this.selectedHarvests[0].body.body.state != 10) {
                            return false
                        }
                        return true
                    // case "change_state":
                    //     if (this.selectedHarvests.length >= 1) {
                    //         return true
                    //     }
                    //     return false
                    case "move":
                        if (this.selectedHarvests.length < 1) {
                            return false
                        }
                        // 選択されている収穫物に廃棄状態が含まれている時は、不可
                        if (this.selectedHarvests.findIndex((v)=>v.body.body.state == 99) >= 0) {
                            return false
                        }
                        return true
                    case "discard":
                        if (this.selectedHarvests.length < 1) {
                            return false
                        }
                        // 選択されている収穫物に廃棄状態が含まれている時は、不可
                        if (this.selectedHarvests.findIndex((v)=>v.body.body.state == 99) >= 0) {
                            return false
                        }
                        return true
                }
            },
            // =============================================
            // ＊＊＊＊＊テスト用
            onClickMovePlace: function () {
                const userUID = this.$store.getters["userUID"]
                var batch = db.batch()
                db.collection("users").doc(userUID).collection("managements").doc("place").collection("places").get().then(function(snapShot){
                    for (var i=0; i<snapShot.size; i++) {
                        const place = snapShot.docs[i].data()
                        batch.set(db.collection("users").doc(userUID).collection("places").doc(""+place.placeID), place)
                    }
                    batch.commit()
                })

                // db.collection("users").doc(userUID).collection("places").get().then(function(snapShot){
                //     snapShot.forEach(function(doc){
                //         db.collection("users").doc(userUID).collection("managements").doc("place").collection("places").doc(""+doc.data().placeID).set(doc.data())
                //     })
                // })
            },
            // =============================================
            // ＊＊＊＊＊テスト用
            onClickRegistTestData: function () {
                const userUID = this.$store.getters["userUID"]
                const currentDateTime = this.df_currentDateTime()
                const items = [
                    {
                        version: "1.0.0",
                        id: 1,
                        order: 1,
                        name: "1果重",
                        unit: "g",
                        data: null,
                        isSystemTemplate: true,
                        register: {userUID: userUID, dateTime:currentDateTime},
                        updater: {userUID: "", dateTime:""},
                    },
                    {
                        version: "1.0.0",
                        id: 10,
                        order: 10,
                        name: "サイズ",
                        unit: "",
                        data: {
                            values: [
                                {value:1, text:"4L"},
                                {value:2, text:"3L"},
                                {value:3, text:"2L"},
                                {value:4, text:"L"},
                                {value:5, text:"M"},
                                {value:6, text:"S"},
                            ]
                        },
                        isSystemTemplate: true,
                        register: {userUID: userUID, dateTime:currentDateTime},
                        updater: {userUID: "", dateTime:""},
                    },
                    {
                        version: "1.0.0",
                        id: 20,
                        order: 20,
                        name: "糖度",
                        unit: "%",
                        data: null,
                        isSystemTemplate: true,
                        register: {userUID: userUID, dateTime:currentDateTime},
                        updater: {userUID: "", dateTime:""},
                    },
                    {
                        version: "1.0.0",
                        id: 21,
                        order: 21,
                        name: "糖度(垂直分布)",
                        unit: "",
                        data: null,
                        isSystemTemplate: true,
                        register: {userUID: userUID, dateTime:currentDateTime},
                        updater: {userUID: "", dateTime:""},
                    },
                    {
                        version: "1.0.0",
                        id: 22,
                        order: 22,
                        name: "糖度(水平分布)",
                        unit: "",
                        data: null,
                        isSystemTemplate: true,
                        register: {userUID: userUID, dateTime:currentDateTime},
                        updater: {userUID: "", dateTime:""},
                    },
                ]

                var batch = db.batch()

                for (var i=0; i<items.length; i++) {
                    const item = items[i]
                    batch.set(db.collection("system").doc("template").collection("observate_items").doc(""+item.id), item)
                }

                batch.commit().then(function(){
                    console.log("regist success")
                }).catch(function(error){
                    console.log("regist failed", error)
                })
            },
        }
    }
</script>

<style>
    th {
        white-space: nowrap
    }
    td {
        white-space: nowrap
    }
</style>
